import { PlanningAPI } from "../../axios";

export const actions = {

    // PlanningRatingScale
    GetPlanningTemplateRatingScale(context, data){
        return PlanningAPI.get(`PlanningTemplateRatingScale/PlanningTemplateMainTarget/${data}`);
    },
    GetSinglePlanningTemplateRatingScale(context, data){
        return PlanningAPI.get(`PlanningTemplateRatingScale/${data}`);
    },
    UpdatePlanningTemplateRatingScale(context, data){
        return PlanningAPI.put(`PlanningTemplateRatingScale/Update/Multiple`, data);
    },
    DeletePlanningTemplateRatingScale(context, data){
        return PlanningAPI.delete(`PlanningTemplateRatingScale/${data}`);
    },
    AddPlanningTemplateRatingScale(context, data){
        return PlanningAPI.post(`PlanningTemplateRatingScale/Add/Multiple`, data);
    },

}